





















































































































































import $ from 'jquery';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import html2canvas from 'html2canvas';
import ComponentMyHero, { Hero } from './components/MyHero.vue';
import ComponentEnemy, { Enemy } from './components/Enemy.vue';
import ComponentNavbar from './components/Navbar.vue';
import { en } from './lang/en';
import { fr } from './lang/fr';
import { cn } from './lang/cn';
import { tw } from './lang/tw';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  silentTranslationWarn: true,
  messages: {
    en,
    fr,
    cn,
    tw,
  },
});

require('./assets/css/dark-mode.css');
require('../node_modules/bootstrap-select/dist/css/bootstrap-select.min.css');
require('../node_modules/bootstrap-select/dist/js/bootstrap-select.min');

export default Vue.extend({
  i18n,
  components: {
    MyHero: ComponentMyHero,
    Enemy: ComponentEnemy,
    Navbar: ComponentNavbar,
  },
  data() {
    return {
      firstHero: {} as Hero,
      secondHero: {} as Hero,
      enemiesFirstHero: {
        first: {} as Enemy,
        second: {} as Enemy,
        third: {} as Enemy,
      },
      enemiesSecondHero: {
        first: {} as Enemy,
        second: {} as Enemy,
        third: {} as Enemy,
      },
      tower: '',
      report: '',
      tempReport: '',
      showRawSpeedData: false,
    };
  },
  watch: {
    'firstHero.name': function (val): void {
      if (val && localStorage.getItem(val)) {
        Vue.set(this.firstHero, 'speed', parseInt(localStorage.getItem(val) as string, 10));
      } else {
        Vue.set(this.firstHero, 'speed', 0);
      }
    },
    'secondHero.name': function (val): void {
      if (val && localStorage.getItem(val)) {
        Vue.set(this.secondHero, 'speed', parseInt(localStorage.getItem(val) as string, 10));
      } else {
        Vue.set(this.secondHero, 'speed', 0);
      }
    },
    showRawSpeedData(): void {
      this.updateReport();
    },
    'firstHero.crBonus': function (): void {
      this.updateReport();
    },
    'firstHero.crPush': function (): void {
      this.updateReport();
    },
    'firstHero.crPushAlly': function (): void {
      this.updateReport();
    },
    'firstHero.speedDown': function (): void {
      this.updateReport();
    },
    'firstHero.speed': function (val): void {
      if (this.firstHero.name && val) {
        localStorage.setItem(this.firstHero.name, val);
      }
      this.updateReport();
    },
    'secondHero.speed': function (val): void {
      if (this.secondHero.name && val) {
        localStorage.setItem(this.secondHero.name, val);
      }
      this.updateReport();
    },
    'secondHero.crBonus': function (): void {
      this.updateReport();
    },
    'secondHero.crPush': function (): void {
      this.updateReport();
    },
    'secondHero.crPushAlly': function (): void {
      this.updateReport();
    },
    'secondHero.speedDown': function (): void {
      this.updateReport();
    },
    tower(): void {
      this.updateReport();
    },
    enemiesFirstHero: {
      deep: true,
      handler(): void {
        this.updateReport();
      },
    },
    enemiesSecondHero: {
      deep: true,
      handler(): void {
        this.updateReport();
      },
    },
  },
  updated() {
    $('.selectpicker').selectpicker('refresh');
    // $('[data-toggle="tooltip"]').tooltip('_fixTitle');
  },
  mounted() {
    /* eslint-disable  dot-notation */
    let langCode = navigator.language || window.navigator['userLanguage'];
    if (langCode === 'zh-TW' || langCode === 'zh-HK' || langCode === 'zh-MO') langCode = 'tw';
    if (langCode === 'zh-CN' || langCode === 'zh-SG') langCode = 'cn';
    if (localStorage.getItem('langCode')) {
      langCode = localStorage.getItem('langCode');
    }
    i18n.locale = langCode;
    document.title = this.$t('title') as string;
    $('[data-toggle="tooltip"]').tooltip({ trigger: 'hover' });
  },
  methods: {
    updateReport(): void {
      this.report = '';
      if (this.tower) {
        this.report += `** ${this.tower} **\r\n`;
      }
      let contentT1 = '';
      if (this.showRawSpeedData && this.firstHero.speed) {
        contentT1 += `【 ${this.$t('repostMySpeedOne')} : ${this.firstHero.speed}】\n`;
      }
      contentT1 += this.updateLine(
        this.enemiesFirstHero.first,
        this.firstHero.speed,
        this.firstHero.crBonus,
        this.firstHero.crPush,
        this.firstHero.crPushAlly,
        this.firstHero.speedDown
      );
      contentT1 += this.updateLine(
        this.enemiesFirstHero.second,
        this.firstHero.speed,
        this.firstHero.crBonus,
        this.firstHero.crPush,
        this.firstHero.crPushAlly,
        this.firstHero.speedDown
      );
      contentT1 += this.updateLine(
        this.enemiesFirstHero.third,
        this.firstHero.speed,
        this.firstHero.crBonus,
        this.firstHero.crPush,
        this.firstHero.crPushAlly,
        this.firstHero.speedDown
      );
      if (contentT1 !== '') {
        this.report += `${this.$t('t1')}\r\n${contentT1}`;
      }
      let contentT2 = '';
      if (this.showRawSpeedData && this.secondHero.speed) {
        contentT2 += `【 ${this.$t('repostMySpeedOne')} : ${this.secondHero.speed}】\n`;
      }
      contentT2 += this.updateLine(
        this.enemiesSecondHero.first,
        this.secondHero.speed,
        this.secondHero.crBonus,
        this.secondHero.crPush,
        this.secondHero.crPushAlly,
        this.secondHero.speedDown
      );
      contentT2 += this.updateLine(
        this.enemiesSecondHero.second,
        this.secondHero.speed,
        this.secondHero.crBonus,
        this.secondHero.crPush,
        this.secondHero.crPushAlly,
        this.secondHero.speedDown
      );
      contentT2 += this.updateLine(
        this.enemiesSecondHero.third,
        this.secondHero.speed,
        this.secondHero.crBonus,
        this.secondHero.crPush,
        this.secondHero.crPushAlly,
        this.secondHero.speedDown
      );
      if (contentT2 !== '') {
        this.report += `${this.$t('t2')}\r\n${contentT2}`;
      }
    },
    updateLine(enemy: Enemy, baseSpeed: number, crBonus = 0, crPush = 0, crPushAlly = 0, speedDown = false): string {
      let content = '';
      if (enemy.name) {
        content += `【 ${enemy.name} 】`;
        content += enemy.artifact ? ` -【 ${enemy.artifact} 】` : '';
        content += enemy.hp ? `-【 ${this.formatHp(enemy.hp)} ${this.$t('hp')} 】` : '';
        if (enemy.cr && baseSpeed) {
          let { cr }: { cr: number } = enemy;
          cr = +cr;
          cr = crPushAlly > 0 ? cr + crPushAlly : cr;
          cr = crPush > 0 ? cr - crPush : cr;
          cr = crBonus > 0 ? (cr * 100) / (crBonus + 100) : cr;
          let crMin = (cr - 5) / 100;
          let crMax = (cr + 5) / 100;
          if (enemy.outspeed) {
            if (speedDown) {
              crMin *= 0.7;
              crMax *= 0.7;
            }
            crMin += 1;
            crMax += 1;
          }

          const speedmin = Math.round(crMin * baseSpeed);
          const speedmax = Math.round(crMax * baseSpeed);
          const speedRange = `${speedmin}-${speedmax}`;
          content += `-【 ${speedRange} ${this.$t('speed')} 】`;
        }
        if (this.showRawSpeedData && enemy.cr) {
          if (enemy.outspeed) {
            content += `-【${this.$t('repostSpeed')} : ${enemy.cr + 100}%】`;
          } else {
            content += `-【${this.$t('repostSpeed')} : ${enemy.cr}%】`;
          }
        }
        content += enemy.counter ? `-【 ${this.$t('setCounter')} 】` : '';
        content += enemy.lifesteal ? `-【 ${this.$t('setLifesteal')} 】` : '';
        content += enemy.injury ? `-【 ${this.$t('setInjury')} 】` : '';
        content += enemy.immunity ? `-【 ${this.$t('setImmunity')} 】` : '';
        content += enemy.infos ? `-【 ${enemy.infos} 】` : '';
        content += '\n';
      }
      return content;
    },
    formatHp(num: number): number | string {
      let numFormated = num > 999 ? num / 1000 + (this.$t('formatHpK') as string) : num;
      if ($('#locale-changer :selected').val() === 'cn' || $('#locale-changer :selected').val() === 'tw') {
        numFormated = num > 9999 ? num / 10000 + (this.$t('formatHpK') as string) : num;
      }
      return numFormated;
    },
    copyToClipboard(): void {
      if ($('#report')) {
        $('#report').select();
        document.execCommand('copy');
        $('.toast').toast('hide');
        $('#copytoast').toast('show');
      }
    },
    copyToClipboardSL(): void {
      if ($('#report')) {
        const copyText = document.querySelector('#report') as HTMLInputElement;
        const ML = copyText.value;
        const SL = ML.replace(/(\r\n|\n|\r)/gm, ' ');
        const slcopy = document.getElementById('sl') as HTMLInputElement;
        if (slcopy !== null) {
          slcopy.value = SL;
          slcopy.select();
          document.execCommand('copy');
          $('.toast').toast('hide');
          $('#slcopytoast').toast('show');
        }
      }
    },
    resetForm(): void {
      document.location.reload();
      $('.toast').toast('hide');
      $('#resettoast').toast('show');
    },
    downloadVisualReport(): void {
      this.tempReport = this.report;
      this.tempReport = this.tempReport.replace(/(\r\n|\n|\r)/gm, '<br/>');
      const capture = this.$refs.capture as HTMLElement;
      const reportimage = document.querySelector('#reportimage') as HTMLElement;
      setTimeout(() => {
        html2canvas(capture, { backgroundColor: '#343a40' })
          .then((canvas) => {
            const a = document.createElement('a');
            a.href = canvas.toDataURL('image/jpeg').replace('image/jpeg', 'image/octet-stream');
            a.download = 'report.jpg';
            a.click();
            reportimage.appendChild(canvas);
            this.tempReport = '';
          })
          .catch((error) => {
            console.log(error);
            this.tempReport = '';
          });
      }, 1);
    },
  },
});
